module.exports = __webpack_public_path__ + "ed8ef5096c0fb063a011990aa3c515eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/amana.png
// module id = 1794
// module chunks = 0